module.exports = __webpack_public_path__ + "static/media/hero-clouds@2x.f776f5d4.jpg";